/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

import '@/styles/layers.css';
import 'vuetify/styles';
// Composables
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { Theme } from '@/constants';
import SoccerBall from '@/pages/core/icon/ball/SoccerBall.vue';
import CornerFlag from '@/pages/core/icon/corner/CornerFlag.vue';

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    defaults: {
        global: {
            density: 'compact',
            flat: true,
        },
        VTextField: {
            clearIcon: mdiClose, //global replace mdiCloseCircle to mdiClose
        },
        VCombobox: {
            clearIcon: mdiClose,
        },
        VSelect: {
            clearIcon: mdiClose,
        },
        VAutocomplete: {
            clearIcon: mdiClose,
        },
        VNumberInput: {
            clearIcon: mdiClose,
        },
        VTooltip: {
            location: 'bottom',
            openDelay: 500,
            openOnFocus: false,
            disabled: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        },
        VDatePicker: {
            VBtn: {
                density: 'default',
            },
        },
        VAppBar: {
            density: 'default',
        },
        VBtn: {
            color: 'primary',
        },
        VBtnToggle: {
            density: 'default',
            VBtn: {
                style: 'text-transform: uppercase; letter-spacing: 0.0892857143em; font-weight: 500;',
            },
        },
        VTab: {
            style: 'text-transform: uppercase; letter-spacing: 0.0892857143em; font-weight: 500;',
        },
        VSwitch: {
            inset: true,
            flat: false,
        },
        VCheckboxBtn: {
            color: 'rgba(0, 0, 0, 0.54)',
            baseColor: 'rgba(0, 0, 0, 0.54)',
            style: 'font-size: 14px;',
        },
        VField: {
            style: 'font-size: 14px;',
        },
    },
    icons: {
        defaultSet: 'mdi',
        aliases: {
            ...aliases,
            soccerBall: SoccerBall,
            cornerFlag: CornerFlag,
        },
        sets: { mdi },
    },
    theme: {
        defaultTheme: Theme.Light,
        themes: {
            light: {
                colors: {
                    primary: '#7a7a7a',
                    tbGreen: '#6aa84f',
                    red: '#f44336',
                    white: '#ffffff',
                    orange: '#ff9800',
                    error: '#ff5252',
                    tbRed: '#f44336',
                    tbBlue: '#4378bb',
                    tbPurple: '#7C3AED',
                    tbYellow: '#f1c232',
                    lightRed: '#fc0d1b',
                    scrollThumb: '#d3d3d3',
                    scrollTrack: '#ffffff',
                    bookmaker10: '#ff5500',
                    bookmaker1: '#002e6c',
                    bookmaker3: '#5372ac',
                    bookmaker11: '#005289',
                    bookmaker5: '#38761d',
                    bookmaker17: '#f5b942',
                    bookmaker19: '#3a343f',
                    bookmaker20: '#ff5500',
                    bookmaker21: '#4da1a9',
                    bookmaker22: '#54292e',
                    bookmaker23: '#642775',
                    infoBlue: '#6fa8dc',
                    statusRunning: '#38761d',
                    successGreen: '#93c47d',
                    timeOrange: '#ff9900',
                    // toast backgrounds
                    toastGreen: '#008000',
                    toastLightGreen: '#4caf50',
                    toastLightRed: '#fc0d1b',
                    toastUpdate: '#1a73e8',
                    // tooltips
                    tooltipTextLight: '#ffffff',
                    tooltipBgLight: '#424242',
                    tooltipBorderLight: '#424242',

                    darkText: '#000000',
                    orangeLighten3: '#ffcc80',
                    actionMenuBorder: '#e0e0e0',
                    actionMenuHover: '#f0f0f0',

                    tableBg: '#ffffff',
                    hiddenFiltersChips: '#7a7a7a',
                },
            },
            dark: {
                colors: {
                    primary: '#7a7a7a',
                    tbGreen: '#6aa84f',
                    red: '#f6475d',
                    white: '#f0f0f0',
                    orange: '#ff9800',
                    error: '#ff5252',
                    tbRed: '#f6475d',
                    tbBlue: '#20b4fe',
                    tbPurple: '#7C3AED',
                    tbYellow: '#f1c232',
                    lightRed: '#fc0d1b',
                    scrollThumb: '#323338',
                    scrollTrack: '#1e1f22',
                    bookmaker10: '#b5bac1',
                    bookmaker1: '#b5bac1',
                    bookmaker3: '#b5bac1',
                    bookmaker11: '#b5bac1',
                    bookmaker5: '#b5bac1',
                    bookmaker17: '#b5bac1',
                    bookmaker19: '#b5bac1',
                    bookmaker20: '#b5bac1',
                    bookmaker21: '#b5bac1',
                    bookmaker22: '#b5bac1',
                    bookmaker23: '#642775',
                    infoBlue: '#6fa8dc',
                    statusRunning: '#38761d',
                    successGreen: '#93c47d',
                    timeOrange: '#ff9900',
                    // toast backgrounds (dark behaves same visual overlays)
                    toastGreen: '#008000',
                    toastLightGreen: '#4caf50',
                    toastLightRed: '#fc0d1b',
                    toastUpdate: '#1a73e8',
                    // tooltips
                    tooltipTextDark: '#f0f0f0',
                    tooltipBgDark: '#2c2d31',
                    tooltipBorderDark: '#3a3b40',

                    darkText: '#b5bac1',
                    orangeLighten3: '#ffcc80',
                    actionMenuBorder: '#404148',
                    actionMenuHover: '#2c2d31',

                    tableBg: '#212121',
                    hiddenFiltersChips: '#acacac',
                },
            },
        },
    },
});
